export enum JourneysCreationTypeEnum {
  rideCreation = "rideCreation",
  rideDuplication = "rideDuplication",
  returnRide = "returnRide",
  connectionRides = "connectionRides",
}
